import { render, staticRenderFns } from "./SMStatusIndicator.vue?vue&type=template&id=0906f145&scoped=true&"
import script from "./SMStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./SMStatusIndicator.vue?vue&type=script&lang=js&"
import style0 from "./SMStatusIndicator.vue?vue&type=style&index=0&id=0906f145&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0906f145",
  null
  
)

export default component.exports